import joi from 'joi';
import { $currencyAttributes, CurrencyAttributes } from './currency';
import { $expirationAttributes, ExpirationAttributes, ExpirationMode } from './expiration';
import { $uuid } from '../../utils';

export interface LevelsConfigAttributes {
  id: string;
  programId: string;
  expiration: ExpirationAttributes;
  currencyId: string;
  timezone: string;
  currency?: CurrencyAttributes;
}

export const $levelExpirationAttributes = $expirationAttributes.keys({
  expirationMode: joi
    .string()
    .valid(...Object.values(ExpirationMode))
    .optional()
    .default(ExpirationMode.REEVALUATE),
});

export interface SetLevelConfigBody {
  currencyId: string;
  expiration: ExpirationAttributes;
  retroActive?: boolean;
}

export const $setLevelConfigBody = joi.object({
  currencyId: joi.string(),
  expiration: $levelExpirationAttributes,
  retroActive: joi.boolean().optional().default(false),
});

export const $levelsConfigAttributes = joi.object<LevelsConfigAttributes>({
  id: $uuid,
  expiration: $levelExpirationAttributes,
  currency: $currencyAttributes.optional(),
  timezone: joi.string().optional().default('utc'),
  programId: $uuid,
  currencyId: $uuid,
});
